import cx from 'classnames'
import { useIntl } from 'react-intl'

import Icon from '../../../Icon/Icon'
import Typography from '../../../Typography/Typography'

import './DropdownToggle.scss'

const DropdownToggle = ({ labelId, open, disabled, onClick, withBorderRadius }) => {
    const intl = useIntl()

    return (
        <button
            className={cx('tgl-btn-row-dropdown-toggle', open && 'toggle-active', withBorderRadius && 'brdr-radius')}
            onClick={() => onClick(!open)}
            disabled={disabled}
        >
            <Typography variant={'buttonPrimary'}>
                {intl.formatMessage({ id: `buttons.toggle.label.${labelId}` })}
            </Typography>
            {open ? <Icon name={'chevron–up'} /> : <Icon name={'chevron–down'} />}
        </button>
    )
}

export default DropdownToggle
